import React, { createContext, useReducer } from 'react'
import { BulkUploadReducer } from '../Reducers/BulkUploadReducer'

export const initialStateBulkUploadReducer = {
  uploadingUsers: false,
  messageBulk: { success: false, message: '' },
}

const Store = ({ children }) => {
  const [state, dispatch] = useReducer(
    BulkUploadReducer,
    initialStateBulkUploadReducer,
  )
  return (
    <ContextBulkUpload.Provider value={[state, dispatch]}>
      {children}
    </ContextBulkUpload.Provider>
  )
}

export const ContextBulkUpload = createContext(initialStateBulkUploadReducer)
export default Store
